import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderUno from '../Metodos/Compartidos/HeaderUno';
import HeaderDos from '../Metodos/Compartidos/HeaderDos';
import { ScreeningTablaPacientes } from '../AuxiliaresPaginas/ScreeningTablaPacientes';

//css
import {Cuerpo, Flex} from '../Css/StyledHeader.js';

import { cargarPacientesScreeningAction } from '../../actions/cargarPacientesScreeningActions.js';
import { generarPDFScreeningAction } from '../../actions/generarPDFActions.js';

import useReturnInitialState from '../../Hooks/useReturnInitialState';
import useConfigAuth from '../../Hooks/useConfigAuth';

const Screening = () => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [returnState] = useReturnInitialState();
    const [config] = useConfigAuth();

    const pacientes = useSelector((state) => state.informacion.lista_pacientes);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);

    const generarPDFAction = (e) => {
        e.preventDefault();
        const informacion = {
                config,
                payload: {
                'id_paciente': id_paciente
                }
            }
        dispatch( generarPDFScreeningAction(informacion) );
    }

    useEffect(() => {
        if(pacientes.length > 0){
            return
        }
        const informacion = {
            config
        }
        const cargoPacientes = () => dispatch (cargarPacientesScreeningAction(informacion));
        cargoPacientes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return ( 
        <Cuerpo>
            <HeaderUno />
            <HeaderDos componente={"Listado pacientes"} paciente={false} />
            <ScreeningTablaPacientes pacientes={pacientes} />
            {/* <Flex>
                <button onClick={(e) => generarPDFAction(e)}>Hola</button>
            </Flex> */}
        </Cuerpo>
    );
}
 
export default Screening;